export default __webpack_public_path__ + "assets/images/appointment_preview_watermark.png";